var runtime = require("../../../../build/webpack-environments/loaders/styles/myCssLoader/runtime.js");
module.exports = {"container":"ukFX3","categories":"_3Kx9R","menu":"_2LmKW","responsive":"_3LN8B"};
module.exports._getCss = function(wrap, process){return ""+wrap+" .ukFX3{display:flex;justify-content:space-between;margin:0 auto}"+wrap+" .ukFX3 ._3Kx9R,"+wrap+" .ukFX3 ._2LmKW{min-width:200px}"+wrap+" ._3LN8B{width:100%;padding:16px 20px 0}" };
module.exports._meta = {moduleId: module.id, order: runtime.getOrder()};

